import React, { FC } from 'react';
import './HeaderLogo.scss';

export const HeaderLogo: FC = () => {
  return <div className="HeaderLogo" />;
};
